module.exports = __webpack_public_path__ + "static/media/img3-1.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_foliar/B/img3-1.png
// module id = 2304
// module chunks = 3